export const addVPSAddon =
  (id, gtmData) =>
  async (dispatch, getState, { api }) =>
    api.addVPS(id).then(
      (isSuccess) => {
        if (isSuccess) {
          window.GTM.pushAddToCart({
            type: "addonProduct",
            location: "In-cart upsell",
            product: gtmData,
          });
        }
        return isSuccess;
      },
      (err) => {
        console.error("Adding VPS product to the basket failed", err);
      },
    );
